module.exports = __webpack_public_path__ + "img/tool3.0349a082.png";